import React from 'react';
import {styled} from '@epic-ui/epic/src/styled-components';
import {withLocalization, LocalizationProps} from 'epic-localization';

const MaintenanceWrapper = styled.div`
    border: 0;
    width: 100%;
    min-height: 600px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
`;

MaintenanceWrapper.displayName = 'MaintenanceWrapper';

const Maintenance: React.FC<LocalizationProps> = ({getMessage}) => (
    <MaintenanceWrapper>
        <div>
            <p>{getMessage('epic.affiliate.hyperwallet.maintenance.message1')}</p>
            <p>{getMessage('epic.affiliate.hyperwallet.maintenance.message2')}</p>
        </div>
    </MaintenanceWrapper>
);

export default withLocalization(Maintenance);
